import {action, autorun, computed, _} from '@api'
import {TabNode} from '@flexlayout'
import {CatalogStore, IFlexLayoutToolbarWindowConfig} from '@stores'
import {synchronizeStores} from '@stores/SynchronizeStores'

export class CatalogAggregationStore {
  constructor(private catalog: CatalogStore) {
    synchronizeStores(() => {
      const toDispose = [

      ]
    })
  }

  @computed get aggregateDetailsGroup() {
    const {catalog: {settings: {aggregateDetailsGroupPath, showAggs}, groupBy: {hierarchyGroups}}, aggregateLocation } = this
    if (!showAggs) return null

    if (aggregateLocation == 'sidebar') {
      const path = _.first(aggregateDetailsGroupPath)
      if (path && path.length <= hierarchyGroups.length) {
        const grouping = hierarchyGroups[path.length - 1]
        if (!grouping?.nodes) {
          return null
        }

        return grouping.nodes.get(grouping.pathLookup(null,path))
      }
    }
    return null
  }

  get aggregateLocation() {
    return this.catalog.settings.aggregateLocation ?? 'sidebar'
  }

  @computed get isShowingDetailsInSidebar() {
    return this.isShowingAggregateDetails && this.aggregateLocation == 'sidebar'
  }
  
  @action onToggleAggregateDetailsLocation = () => {
    const {catalog: {settings, flexLayout, flexLayout: {isMaximized}, sidebar}, aggregateLocation} = this
    settings.aggregateLocation = aggregateLocation == 'sidebar' ? 'inline' : 'sidebar'
    if (settings.aggregateLocation === 'inline') {
      settings.showAggs = true
    }
  }

  @computed get hasAggregations() {
    return !_.isEmpty(this.catalog.features?.groupBy?.detailAggregations)
  }

  @computed get isShowingAggregateDetails() {
    return this.aggregateDetailsGroup != null || (this.catalog.settings.showAggs && this.catalog.isProductView)
  }

  @action closeAggregateDetails = () => {
    const { catalog: {settings, flexLayout: {isMaximized, toggleKnownTab}}} = this
    settings.aggregateDetailsGroupPath = []
    settings.showAggs = false

    if (!isMaximized) {
      toggleKnownTab('catalogAggregateDetails', false)
    }
  }

  @action toggleAggregationGroup = (pathIncludingSelfKeys: string[]) => {
    const {catalog: {settings, settings: {aggregateDetailsGroupPath}}, aggregateLocation} = this
    const activeIndex = aggregateDetailsGroupPath.findIndex(p => _.isEqual(pathIncludingSelfKeys, p))

    if (aggregateLocation == 'sidebar') {
      settings.aggregateDetailsGroupPath = activeIndex == 0 ? [] : [pathIncludingSelfKeys]
    } else {
      if (activeIndex == -1) {
        settings.aggregateDetailsGroupPath = [...aggregateDetailsGroupPath, pathIncludingSelfKeys]
      } else {
        settings.aggregateDetailsGroupPath = aggregateDetailsGroupPath.filter((f, i) => i != activeIndex)
      }
    }
  }

  @action onToggleShowAggs = () => {
    const {catalog: {settings, flexLayout: {isMaximized, toggleKnownTab}}} = this
    settings.showAggs = !settings.showAggs
    if (settings.showAggs && settings.aggregateLocation === 'sidebar' && !isMaximized) {
      toggleKnownTab('catalogAggregateDetails', true)
    }
  }

  @action onToggleShowAggDetailsWhenCollapsed = () => {
    this.catalog.settings.showAggDetailsWhenCollapsed = !this.catalog.settings.showAggDetailsWhenCollapsed
  }
}


// WEBPACK FOOTER //
// ./src/stores/catalog/CatalogAggregationStore.ts